export default "__VITE_ASSET__47bfbb2a__"